function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "umbrella"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 2c-5.514 0-10 4.486-10 10 0 .553.448 1 1 1h8v6.5c0 1.379 1.122 2.5 2.5 2.5 1.379 0 2.5-1.121 2.5-2.5 0-.553-.447-1-1-1s-1 .447-1 1c0 .275-.225.5-.5.5s-.5-.225-.5-.5v-6.5h8c.553 0 1-.447 1-1 0-5.514-4.486-10-10-10zm2.973 9h-5.946c.222-4.304 1.836-7 2.973-7 1.138 0 2.751 2.696 2.973 7zm-6.527-6.166c-.796 1.578-1.311 3.717-1.423 6.166h-2.961c.339-2.706 2.036-4.996 4.384-6.166zm8.531 6.166c-.111-2.449-.627-4.588-1.423-6.166 2.349 1.17 4.045 3.46 4.384 6.166z"
}));

var Svg122Umbrella = function Svg122Umbrella(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg122Umbrella, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/122-umbrella.086ee750.svg";
export { ForwardRef as ReactComponent };